import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { throwError } from 'rxjs';
import { catchError, finalize, take } from 'rxjs/operators';
import { MenuEventService } from 'src/app/layers/actions/map-actions/menu-event.service';
import { MapDrawService } from 'src/app/shared/components/map/map-draw.service';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { SimulationAreaResultComponent } from '../simulation-area-result/simulation-area-result.component';
import { CheckSimulatioArea, createSimulation, Simulation, SimulationAreaResult } from '../state/simulation.model';
import { SimulationQuery } from '../state/simulation.query';
import { SimulationService } from '../state/simulation.service';
import {AppError} from '../../core/errors/http-error/app-error';

@Component({
  selector: 'app-simulation-area-form',
  templateUrl: './simulation-area-form.component.html',
  styleUrls: ['./simulation-area-form.component.scss']
})
export class SimulationAreaFormComponent implements OnInit, OnDestroy {

  simulation: Simulation;
  formArray = this.formBuilder.array([]);
  error: AppError;

  isSending: boolean;

  constructor(
    private simulationService: SimulationService,
    private simulationQuery: SimulationQuery,
    private windowService: WindowService,
    private formBuilder: FormBuilder,
    private drawService: MapDrawService,
    private menuEventService: MenuEventService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.menuEventService.active = false;
    this.drawService.disable();

    this.simulation = createSimulation(this.simulationQuery.getActive());

    this.initForms();
  }

  ngOnDestroy(): void {
    this.menuEventService.active = true;
    this.drawService.enable();
  }

  save() {
    this.isSending = true;
    this.simulation.attendance_rates = this.formArray.value;

    this.simulationService.update(this.simulation.id, this.simulation)
      .pipe(
        take(1),

        catchError(error => {
          this.isSending = false;
          this.snackBar.open($localize`Error on save simulation`, $localize`CLOSE`);
          return throwError(error);
        }))
      .subscribe(() => this.checkAreas());
  }

  areaValidated(result: SimulationAreaResult) {
    const titleConfig = $localize`NETWORK AREA RESULT`;
    this.windowService.open({
      title: titleConfig,
      componentType: SimulationAreaResultComponent,
      help: 'COVERAGE_AREA',
      config: {
        id: 'SIMULATION_AREA_RESULT',
        data: result
      }
    });
    this.windowService.closeByClass(SimulationAreaFormComponent);
  }

  private initForms() {

    this.simulation.attendance_rates.forEach(a => {
      const formGroup = this.formBuilder.group({
        economic_class: [a.economic_class, Validators.required],
        individual_res_rate: [a.individual_res_rate, [Validators.required, Validators.min(0), Validators.max(100)]],
        individual_nres_rate: [a.individual_nres_rate, [Validators.required, Validators.min(0), Validators.max(100)]],
        collective_res_rate: [a.collective_res_rate, [Validators.required, Validators.min(0), Validators.max(100)]],
        collective_nres_rate: [a.collective_nres_rate, [Validators.required, Validators.min(0), Validators.max(100)]],
      });
      this.formArray.push(formGroup);
    });
  }

  private checkAreas() {
    const { areas_definition, attendance_rates } = this.simulation;
    const check: CheckSimulatioArea = { areas_definition, attendance_rates };
    this.error = null;
    this.simulationService.checkSimulationAreas(check)
      .pipe(
        finalize(() => this.isSending = false),
        catchError(error => {
          this.error = error;
          // this.snackBar.open($localize`Error on check areas`, $localize`CLOSE`);
          return throwError(error);
        })
      )
      .subscribe(result => {
        this.areaValidated(result);
      });
  }

  close() {
    this.windowService.closeByClass(SimulationAreaFormComponent);
  }
}
